import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/services/api.service';
import { ImageService } from 'src/app/services/image.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-consult-us-number',
  templateUrl: './consult-us-number.component.html',
  styleUrls: ['./consult-us-number.component.css']
})
export class ConsultUsNumberComponent implements OnInit {

    errorMsg: any = [];
    sno = 1;
    showPopup = false;
    loading = false;
    ConsultUsList: any = [];
    branchname: any;
    Address :any;
    mobileno :any;
    maplink :any;
    editBannerId = '';
    modalBoxName;
    loadingBtn = false;
    viewBox = false;
    showImage = true;
    Usertypes: any = [];
    typename:any;
    edittypename=0;

    constructor(
        private apiService: ApiService,
        private toastr: ToastrService,
        private imageService: ImageService
    ) { }

    ngOnInit() {
        this.index();
        this.getAllTypes();
    }

    index() {
        this.loading = true;
        this.apiService.index('consultUsNumber').subscribe(data => {
            this.ConsultUsList = data.data;
            this.loading = false;
        });
    }

    getAllTypes() {
      this.Usertypes = [];
      this.loading = true;
      this.apiService.getData('getActiveConsultUs').subscribe(data => {
          const Usertypes = data.data;
          for (const users of Usertypes) {
              this.Usertypes.push({ id: users.id, name: users.branch });
          }
      });
  }

    store() {
        this.loadingBtn = true;
        this.apiCall('store', 'consultUsNumber');
    }

    show(id) {
        this.apiService.show('consultUsNumber/' + id).subscribe((data) => {
            const value = data.data;
            this.edittypename = value.brand_id;
            this.mobileno = value.number;
            this.editBannerId = id;
        });
    }

    update(id) {
        this.loadingBtn = true;
        this.apiCall('update', 'consultUsNumber/' + id);
    }

    destroy(id) {
        this.swalCall(id);
    }

    ConsultSwitch(id) {
        this.apiCall('getData', 'consultUsNumberSwitch/' + id);
    }

    apiCall(name, url, value: any = '') {
        value = name === 'store' || name === 'update' ? {
            brand_id : this.edittypename,
            number: this.mobileno,
        } : value;
        this.apiService[name](url, value).subscribe((data) => {
            if (data.error === false) {
                this.toastr.success(data.message);
                this.loadingBtn = false;
                this.popUpClose();
                this.index();
            } else {
                this.toastr.error(data.message);
                this.loadingBtn = false;
                this.errorMsg = data.data;
            }
        });
    }

    openModalBox(id = '') {
        if (id) {
            this.modalBoxName = 'Edit';
            this.show(id);
        } else {
            this.modalBoxName = 'Create';
        }
        this.showPopup = true;
    }

    popUpClose() {
        this.showPopup = false;
        this.branchname  = this.editBannerId = '';
        this.mobileno  = '';
        this.errorMsg = [];
        this.viewBox = false;
        this.edittypename = 0;
    }

    keyPress(event, type, id = '') {
        if (event.keyCode === 13) {
            if (type === 'Create') {
                this.store();
            } else if (type === 'Edit') {
                this.update(id);
            }
        }
    }

    swalCall(id) {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this data!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
        }).then((result) => {
            if (result.value) {
                this.apiCall('destroy', 'consultUsNumber/' + id);
                Swal.fire(
                    'Deleted!',
                    'Your data has been deleted.',
                    'success'
                );
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire(
                    'Cancelled',
                    'Your data is safe.',
                    'error'
                );
            }
        });
    }
}
